module.exports = __webpack_public_path__ + "static/em_header-27b4def0195dfebfbecef5866c897fb9.png";